import axios from "axios"

export const CampaignProductApi = {
    Sun:{
        async CreateOrUpdate(update,data){
            const response = await axios.post(update? '/api/campaignproduct/update/sun': '/api/campaignproduct/create/sun',data)
            return response
        },
        async Delete(data){
            const response = await axios.post(`/api/campaignproduct/delete/sun/${data}`)
            return response
        },
        async List(){
            const response = await axios.get('/api/campaignproduct/list/sun')
            return response
        },
        async Table(data){
            const response = await axios.post('/api/campaignproduct/table/sun',data)
            return response
        }
    }
    
}